// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

let chartData;
let metaData;

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta)
      .forEach((id) => {
        const node = document.querySelector(`.${id}`);

        if (node) {
          node.innerHTML = meta[id];
        }
      });
  }
  const { pymChild } = window;

  d3.json('https://ix.cnn.io/data/wx-hurricane-overview/stormnames.json').then((d) => {
    chartData = d.data['2024'].names;
    metaData = d.metadata;

    draw();
    window.onresize = draw();
  });
};

function draw() {
  const container = d3.select('#graphic');
  container.html('');

  const stormNames = Object.keys(chartData);

  const list = container.append('ul')
    .attr('class', 'storm-names');


  console.log(stormNames);

  list.selectAll('li')
    .data(stormNames)
    .enter()
    .append('li')
    .attr('class', d => (chartData[d].storm ? 'storm-yes' : 'storm-no'))
    .text(d => d);

  pymChild.sendHeight();
}
